import { useProgress } from '@react-three/drei';
import { useState, useEffect } from 'react';

export const LoadingScreen = () => {
    const { active, progress } = useProgress();
    const [done, setDone] = useState(false);
    const [visible, setVisible] = useState(true);

    // Fade out logic with timeout fallback
    useEffect(() => {
        let timeout: any = null;

        if (!active && progress >= 100) {
            setDone(true);
            timeout = setTimeout(() => setVisible(false), 500);
        } else if (!active && progress === 0) {
            // Some loaders don't report progress; hide after a short fallback timeout
            timeout = setTimeout(() => {
                setDone(true);
                setVisible(false);
            }, 6000);
        } else {
            setDone(false);
            setVisible(true);
        }

        return () => clearTimeout(timeout);
    }, [active, progress]);

    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#050510',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            zIndex: 9999,
            opacity: done ? 0 : 1,
            transition: 'opacity 0.5s ease-out',
            pointerEvents: done ? 'none' : 'auto',
            fontFamily: "'Inter', sans-serif"
        }}>
            <h1 style={{ marginBottom: '20px', letterSpacing: '2px', textTransform: 'uppercase' }}>Creating World...</h1>

            <div style={{
                width: '300px',
                height: '6px',
                background: '#111',
                borderRadius: '3px',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 0 10px rgba(0,0,0,0.6)'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: `${Math.min(100, Math.max(0, progress))}%`,
                    background: 'linear-gradient(90deg,#00ffff,#4a90ff)',
                    boxShadow: '0 0 12px rgba(0,255,255,0.6)',
                    transition: 'width 0.2s ease-out'
                }} />
            </div>

            <div style={{ marginTop: '10px', fontSize: '12px', color: '#ccc' }}>
                {progress > 0 ? `${Math.round(progress)}%` : 'Loading…'}
            </div>
        </div>
    );
};
